/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {KTSVG} from '../../../helpers'
import {UserMenu} from '../user-menu/UserMenu'

const AsideUserMenu: FC = () => {
  const {currentUser} = useAuth()

  const displayName =
    currentUser?.first_name && currentUser?.last_name
      ? `${currentUser.first_name} ${currentUser.last_name}`
      : currentUser?.name || 'User'

  const initials = displayName
    .split(' ')
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)

  return (
    <div style={{display: 'flex', alignItems: 'center', gap: 8, minHeight: 36}}>
      {/* Avatar */}
      <Link to='/account' style={{flexShrink: 0}}>
        {currentUser?.image ? (
          <img
            src={currentUser.image}
            alt='avatar'
            style={{
              width: 30,
              height: 30,
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid rgba(232,64,64,0.3)',
            }}
          />
        ) : (
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #E84040 0%, #6366f1 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              fontWeight: 700,
              color: '#fff',
              flexShrink: 0,
            }}
          >
            {initials}
          </div>
        )}
      </Link>

      {/* Name & follower */}
      <div style={{flex: 1, minWidth: 0}}>
        <Link
          to='/account'
          style={{
            display: 'block',
            color: '#e2e8f0',
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: 1.15,
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {displayName}
        </Link>
        <span style={{color: '#64748b', fontSize: '10px', fontWeight: 500, lineHeight: 1.1}}>
          {currentUser?.followings ?? 0} followers
        </span>
      </div>

      {/* Settings icon */}
      <div
        className='btn btn-sm btn-icon position-relative'
        data-kt-menu-trigger='click'
        data-kt-menu-overflow='false'
        data-kt-menu-placement='top-end'
        style={{color: '#64748b', flexShrink: 0, width: 28, height: 28}}
      >
        <KTSVG path='/media/icons/duotune/coding/cod001.svg' className='svg-icon-1' />
      </div>
      <UserMenu />
    </div>
  )
}

export {AsideUserMenu}
